import {
  Col, Flex, Row, Typography
} from "antd";
import { useTranslation } from "react-i18next";
import Chat from "../../components/Chat";
import useCurrentUser from "../../hooks/useCurrentUser";
import Patients from "../../components/Chat/patients";
import classes from "./messages.module.css";
import CurrentDoctor from "../../components/CurrentDoctor";

const { Title } = Typography;

const Messages = () => {
  const { t } = useTranslation();
  const { isDoctor } = useCurrentUser();

  return (
    <Flex vertical className={classes.root}>
      <Title level={4}>{t("messagesPage.title")}</Title>
      <Row gutter={[30, 16]} className={classes.container}>
        <Col span={24} xl={isDoctor ? 18 : 17} className={classes.chat}>
          <Chat />
        </Col>
        <Col span={24} xl={isDoctor ? 6 : 7} className={classes.patients}>
          {isDoctor ? (
            <Patients/>
          ) : <CurrentDoctor/>}
        </Col>
      </Row>
    </Flex>
  );
};

export default Messages;
